import React from "react";
import "./BootcampPerformanceOutcomes.css";
import tradeClass from "../../images/marnusTrade.webp";
import chartBg from "../../images/Chart 4.webp";

const performanceOutcomes = [
  {
    id: "market-structure",
    icon: "structure",
    title: "Read Market Structure",
    body: "Spot trends, ranges, breakouts and key levels.",
  },
  {
    id: "trade-plan",
    icon: "plan",
    title: "Plan Every Trade",
    body: "Define setup, entry, stop, target and risk.",
  },
  {
    id: "simulation",
    icon: "simulation",
    title: "Execute in Simulation",
    body: "Practise one setup through replay and demo.",
  },
  {
    id: "risk",
    icon: "risk",
    title: "Manage Risk First",
    body: "Size positions, set limits and protect capital.",
  },
  {
    id: "review",
    icon: "review",
    title: "Review Performance",
    body: "Journal screenshots, mistakes and process scores.",
  },
  {
    id: "playbook",
    icon: "playbook",
    title: "Present Your Playbook",
    body: "Leave with tested rules and a 90-day roadmap.",
    featured: true,
  },
];

const marketCandles = [
  "green",
  "green",
  "red",
  "green",
  "red",
  "green",
  "green",
  "red",
  "green",
  "green",
];

const outcomeTrends = ["gold", "green", "green", "red", "green", "gold"];

const getOutcomeTrend = (index) => outcomeTrends[index] || "green";

function OutcomeIcon({ name }) {
  switch (name) {
    case "structure":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4.75 18.25h14.5" />
          <path d="M6.25 15.8 9.5 12.55l2.45 2.1 5.8-7.1" />
          <path d="M6.25 8.25v8.6" />
          <path d="M12 6.25v9.55" />
          <path d="M17.75 5.25v10.1" />
        </svg>
      );

    case "plan":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7.25 5.25h9.5c.85 0 1.5.65 1.5 1.5v12c0 .85-.65 1.5-1.5 1.5h-9.5c-.85 0-1.5-.65-1.5-1.5v-12c0-.85.65-1.5 1.5-1.5Z" />
          <path d="M9.25 9.1h5.7" />
          <path d="M9.25 12.25h5.7" />
          <path d="M9.25 15.4h3.6" />
          <path d="M9.15 3.75h5.7" />
        </svg>
      );

    case "simulation":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4.75 18.25h14.5" />
          <path d="M6.25 15.2c1.3-2.65 3.05-3.4 5.1-2.15 2.2 1.32 4.35.52 6.4-3.45" />
          <path d="m10.25 7.25 5.6 3.25-5.6 3.25V7.25Z" />
        </svg>
      );

    case "risk":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 3.75 18.4 6.2v4.75c0 4.05-2.35 7.4-6.4 9.3-4.05-1.9-6.4-5.25-6.4-9.3V6.2L12 3.75Z" />
          <path d="m9.35 12.1 1.75 1.75 3.65-4.1" />
        </svg>
      );

    case "review":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6.25 4.75h9.9c.85 0 1.55.7 1.55 1.55v13.2H7.7c-.95 0-1.7-.75-1.7-1.7V5c0-.14.11-.25.25-.25Z" />
          <path d="M7.7 19.5c-.95 0-1.7-.75-1.7-1.7s.75-1.7 1.7-1.7h10" />
          <path d="M9.25 8.25h4.8" />
          <path d="M9.25 11.05h5.8" />
          <path d="M9.25 13.85h3.9" />
        </svg>
      );

    case "playbook":
    default:
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M5.25 5.4c0-.78.62-1.4 1.4-1.4h10.7c.78 0 1.4.62 1.4 1.4v14.35l-6.75-2.6-6.75 2.6V5.4Z" />
          <path d="M8.65 8.5h6.7" />
          <path d="M8.65 11.25h5.2" />
          <path d="m9.05 14.35 1.35 1.25 3.25-3.65" />
        </svg>
      );
  }
}

function BootcampPerformanceOutcomes() {
  return (
    <section
      className="trpc-performance"
      aria-labelledby="trpc-performance-title"
    >
      <div className="trpc-performance-shell">
        <article className="trpc-performance-board">
          <div className="trpc-performance-chartLayer" aria-hidden="true">
            <img
              className="trpc-performance-chart"
              src={chartBg}
              alt=""
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className="trpc-performance-marketLayer" aria-hidden="true">
            <span className="trpc-performance-priceLine" />

            <div className="trpc-performance-candleGroup">
              {marketCandles.map((trend, index) => (
                <span
                  key={`${trend}-${index}`}
                  className="trpc-performance-candle"
                  data-trend={trend}
                />
              ))}
            </div>
          </div>

          <div className="trpc-performance-media">
            <img
              className="trpc-performance-image"
              src={tradeClass}
              alt="Students attending a live trading class"
              loading="lazy"
              decoding="async"
            />

            <div className="trpc-performance-mediaOverlay" aria-hidden="true" />

            <div className="trpc-performance-heroCopy">
              <span className="trpc-performance-kicker">
                Performance Outcomes
              </span>

              <h2 id="trpc-performance-title" className="trpc-performance-title">
                Trade with a clear process
              </h2>

              <p className="trpc-performance-subtitle">
                Build the process to trade part-time or pursue a full-time
                trading pathway.
              </p>

              <a
                className="trpc-performance-cta"
                href="https://andus.co.za/trade-register"
                target="_blank"
                rel="noopener noreferrer"
                data-candle="green"
              >
                <span>Apply now</span>
              </a>
            </div>
          </div>

          <div
            className="trpc-performance-processPanel"
            aria-label="Practical execution and performance outcomes"
          >
            <div className="trpc-performance-panelTop" aria-hidden="true">
              <span className="trpc-performance-panelRule" />

              <div className="trpc-performance-panelTicker">
                {marketCandles.slice(0, 7).map((trend, index) => (
                  <span
                    key={`panel-${trend}-${index}`}
                    className="trpc-performance-miniCandle"
                    data-trend={trend}
                  />
                ))}
              </div>
            </div>

            <ol className="trpc-performance-list">
              {performanceOutcomes.map((item, index) => (
                <li
                  className={
                    item.featured
                      ? "trpc-performance-item trpc-performance-item-featured"
                      : "trpc-performance-item"
                  }
                  key={item.id}
                  data-trend={getOutcomeTrend(index)}
                >
                  <span className="trpc-performance-step" aria-hidden="true">
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  <span className="trpc-performance-icon" aria-hidden="true">
                    <OutcomeIcon name={item.icon} />
                  </span>

                  <div className="trpc-performance-cardCopy">
                    <h3 className="trpc-performance-cardTitle">{item.title}</h3>
                    <p className="trpc-performance-cardText">{item.body}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </article>
      </div>
    </section>
  );
}

export default BootcampPerformanceOutcomes;